import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { useSite } from "@/lib/i18n";
import { api } from "@/lib/api";

const Col = ({ title, children }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{title}</p>
    <ul className="mt-4 space-y-2.5 text-sm text-slate-300">{children}</ul>
  </div>
);
const L = ({ to, children, id }) => (
  <li><Link to={to} data-testid={id} className="hover:text-white transition-colors">{children}</Link></li>
);

export function Footer() {
  const { site } = useSite();
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/public/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);
  return (
    <footer className="bg-navy text-slate-300 relative" data-testid="site-footer">
      <div className="wrap grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2 max-w-sm">
          <Logo dark testid="footer-logo" />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">{site.about?.who?.slice(0, 180)}…</p>
          <ul className="mt-6 space-y-2 text-sm">
            {site.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-signal" /><a href={`mailto:${site.email}`} data-testid="footer-email">{site.email}</a></li>}
            {(site.phones || []).map((p) => (
              <li key={p} className="flex items-center gap-2"><Phone className="h-4 w-4 text-signal" /><a href={`tel:${p.replace(/\s|-/g, "")}`}>{p}</a></li>
            ))}
            {site.website && <li className="flex items-center gap-2"><Globe className="h-4 w-4 text-signal" />{site.website}</li>}
          </ul>
          {(site.socials || []).length > 0 && (
            <div className="mt-5 flex gap-4 text-sm">
              {site.socials.map((s) => <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" className="hover:text-white">{s.name}</a>)}
            </div>
          )}
        </div>
        <Col title="Productos">
          {products.length ? products.slice(0, 6).map((p) => <L key={p.id} to={`/soluciones/${p.slug}`}>{p.name}</L>) : <li className="text-slate-500">Catálogo en preparación</li>}
          <L to="/soluciones" id="footer-solutions">Ver catálogo</L>
        </Col>
        <Col title="Servicios">
          {services.slice(0, 6).map((s) => <L key={s.id} to={`/servicios/${s.slug}`}>{s.title}</L>)}
        </Col>
        <Col title="Enlaces">
          <L to="/nosotros">Nosotros</L><L to="/clientes">Clientes y casos</L><L to="/recursos">Recursos</L>
          <L to="/preguntas-frecuentes" id="footer-faq">Preguntas frecuentes</L><L to="/contacto">Contacto</L><L to="/acceso">Portal de clientes</L>
        </Col>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap flex flex-col gap-3 py-6 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {site.company || "Cloud Center Costa Rica"}. Todos los derechos reservados.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-white">Política de privacidad</Link>
            <Link to="/legal/terms" data-testid="footer-terms" className="hover:text-white">Términos y condiciones</Link>
            <Link to="/legal/commercial" data-testid="footer-commercial" className="hover:text-white">Condiciones comerciales</Link>
            <Link to="/legal/legal_info" data-testid="footer-legal" className="hover:text-white">Información legal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
